let browser = navigator.userAgent.toLowerCase();
let flag = {};
if (browser.match(/Alipay/i) == "alipay") {
    flag.id = "12";
    flag.name = 'ali'
} else if (browser.match(/MicroMessenger/i) == "micromessenger") {
    flag.id = "13";
    flag.name = "wx"

} else {
    flag = {};
    alert("请使用微信/支付宝扫码");

}

export default flag
